import React from 'react'
import { Tabs } from 'antd';
import Description from './Description';
import Comments from './Comments';
const onChange = key => {
  console.log(key);
};

const Products_Review_Tabs = ({product}) => {
  const items = [
  {
    key: '1',
    label: 'Description',
    children: <Description product={product}/>,
  },
  {
    key: '2',
    label: 'Reviews',
    children: <Comments product={product}/>,
  },
  
];
  return (
  <Tabs
      defaultActiveKey="1"
      items={items}
      onChange={onChange}
      tabBarGutter={20} // gap between tabs
      className='custom-tabs'
     
    />
  )
}

export default Products_Review_Tabs
